export const EXTENSION_AUDIO_FILE = ['wav', 'WAV', 'aif', 'AIF', 'mp3', 'MP3', 'mid', 'MID']
export const TIME_CHECK_STATUS = 3 * 1000
export const TIME_CHECK_LOG_OFF = 15 * 1000
export const TIME_CHECK_CALLING = 15 * 1000
